/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChangeEntryKind } from './ChangeEntryKind';
import {
    ChangeEntryKindFromJSON,
    ChangeEntryKindFromJSONTyped,
    ChangeEntryKindToJSON,
    ChangeEntryKindToJSONTyped,
} from './ChangeEntryKind';

/**
 * 
 * @export
 * @interface ClientChangeInfoResponse
 */
export interface ClientChangeInfoResponse {
    /**
     * 
     * @type {Date}
     * @memberof ClientChangeInfoResponse
     */
    createdAtUtc: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ClientChangeInfoResponse
     */
    createdByUserCode: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ClientChangeInfoResponse
     */
    lastModifiedAtUtc: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ClientChangeInfoResponse
     */
    lastModifiedByUserCode: string | null;
    /**
     * 
     * @type {ChangeEntryKind}
     * @memberof ClientChangeInfoResponse
     */
    lastChangeKind: ChangeEntryKind | null;
}



/**
 * Check if a given object implements the ClientChangeInfoResponse interface.
 */
export function instanceOfClientChangeInfoResponse(value: object): value is ClientChangeInfoResponse {
    if (!('createdAtUtc' in value) || value['createdAtUtc'] === undefined) return false;
    if (!('createdByUserCode' in value) || value['createdByUserCode'] === undefined) return false;
    if (!('lastModifiedAtUtc' in value) || value['lastModifiedAtUtc'] === undefined) return false;
    if (!('lastModifiedByUserCode' in value) || value['lastModifiedByUserCode'] === undefined) return false;
    if (!('lastChangeKind' in value) || value['lastChangeKind'] === undefined) return false;
    return true;
}

export function ClientChangeInfoResponseFromJSON(json: any): ClientChangeInfoResponse {
    return ClientChangeInfoResponseFromJSONTyped(json, false);
}

export function ClientChangeInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientChangeInfoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAtUtc': (json['createdAtUtc'] == null ? null : new Date(json['createdAtUtc'])),
        'createdByUserCode': json['createdByUserCode'],
        'lastModifiedAtUtc': (json['lastModifiedAtUtc'] == null ? null : new Date(json['lastModifiedAtUtc'])),
        'lastModifiedByUserCode': json['lastModifiedByUserCode'],
        'lastChangeKind': ChangeEntryKindFromJSON(json['lastChangeKind']),
    };
}

export function ClientChangeInfoResponseToJSON(json: any): ClientChangeInfoResponse {
    return ClientChangeInfoResponseToJSONTyped(json, false);
}

export function ClientChangeInfoResponseToJSONTyped(value?: ClientChangeInfoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAtUtc': value['createdAtUtc'] == null ? value['createdAtUtc'] : value['createdAtUtc'].toISOString(),
        'createdByUserCode': value['createdByUserCode'],
        'lastModifiedAtUtc': value['lastModifiedAtUtc'] == null ? value['lastModifiedAtUtc'] : value['lastModifiedAtUtc'].toISOString(),
        'lastModifiedByUserCode': value['lastModifiedByUserCode'],
        'lastChangeKind': ChangeEntryKindToJSON(value['lastChangeKind']),
    };
}

